import { render, staticRenderFns } from "./TheVideoList.vue?vue&type=template&id=6670aea8&"
import script from "./TheVideoList.vue?vue&type=script&lang=js&"
export * from "./TheVideoList.vue?vue&type=script&lang=js&"
import style0 from "./TheVideoList.vue?vue&type=style&index=0&id=6670aea8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports